export default __webpack_public_path__ + "static/media/keyvis_players_dt.1aa2064a.png";